import {FormControl, FormGroup, Validators} from '@angular/forms';
import {CustomValidators} from '@narik/custom-validators';
import {T4Validators} from '@tymes4-shared';
import {ContactValidator} from '../../helpers/contact-validator';

export function createPrimaryContactForm(contactValidator: ContactValidator): FormGroup {
  return new FormGroup({
    Id: new FormControl(),
    CustomerId: new FormControl(),
    Initials: new FormControl('', [Validators.maxLength(20)]),
    FirstName: new FormControl('', [Validators.maxLength(50), Validators.required]),
    MiddleName: new FormControl('', [Validators.maxLength(50)]),
    LastName: new FormControl('', [Validators.maxLength(50), Validators.required]),
    Email: new FormControl(null, [CustomValidators.email], [contactValidator.emailTaken]),
    MobileNr: new FormControl('', [T4Validators.validatePhonenumber]),
    Gender: new FormControl(''),
    DateOfBirth: new FormControl(null, {updateOn: 'blur', validators: [CustomValidators.minDate(new Date(1900, 0, 1)), CustomValidators.maxDate(new Date())]}),
    Primary: new FormControl(true),
    Active: new FormControl(true),
    LanguageId: new FormControl(null),
    SSOId: new FormControl(),
  });
}
